import AssessmentCategoriesPie from "pages/PanelPage/components/charts/AssessmentCategoriesPie/AssessmentCategoriesPie";

export default AssessmentCategoriesPie;
